import Box from '@mui/material/Box';
import MLink from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import UrlLink from '@/components/url-link';
import { instagramUrl } from '@/utils/urls';
import type { Group } from '@/types/Group';

interface Props {
  groups: Group[] | null;
}

export default function FoundGroupList({ groups }: Props) {
  if (!groups || groups.length === 0) {
    return null;
  }

  return (
    <Box component="ul" sx={{ listStyle: 'none', p: 0, m: 0, display: 'flex', flexDirection: 'column', gap: 1.5 }}>
      {groups.map((group) => (
        <li key={group.id}>
          <Typography variant="body1" component="span" sx={{ fontWeight: 'bold' }}>
            {group.name}
          </Typography>
          {(group.websiteUrl || group.instagramUsername) && (
            <Typography variant="body2" component="span" color="text.secondary">
              {' — '}
              {group.websiteUrl && <UrlLink url={group.websiteUrl} />}
              {group.websiteUrl && group.instagramUsername && ' · '}
              {group.instagramUsername && (
                <MLink href={instagramUrl(group.instagramUsername)!} rel="noopener noreferrer">
                  @{group.instagramUsername.replace(/^@/, '')}
                </MLink>
              )}
            </Typography>
          )}
          {group.summary && (
            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>
              {group.summary}
            </Typography>
          )}
        </li>
      ))}
    </Box>
  );
}
